export const SWITCH_MENU = 'SWITCH_MENU';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_ALERT = 'SHOW_ALERT';
